import React from 'react';
import ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';
// redux
import { Provider, connect } from 'react-redux';
import applyConfigSettings from './config';
import createStore from './redux';

import DefaultApp from './components/App';
import StandaloneSceneApp from './components/StandaloneSceneApp';
import I18nConfig from './config/I18nConfig';
import './styles/main.scss';
import Spinner from './components/util/Spinner';

// Apply config overrides
applyConfigSettings();
// Wrap ReactDOM.render call

const store = createStore();

const render = AppComponent => {
    ReactDOM.render(
        <AppContainer>
            <Provider store={store}>
                <I18nConfig>
                    <Spinner>
                        <AppComponent />
                    </Spinner>
                </I18nConfig>
            </Provider>
        </AppContainer>,
        document.getElementById('caravan-configurator-app')
    );
};

const App = global.standaloneScene ? StandaloneSceneApp : DefaultApp;
const ConnectedApp = connect((state) => state)(App);
render(ConnectedApp);
if (module.hot) {
    // Enable HMR updates
    module.hot.accept('./components/App', () => render(ConnectedApp));
}

